var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard31(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_31);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Ellipse_305);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_305",
    x: -0.921,
    y: 2.158,
    width: 46.842,
    height: 46.842,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.157
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_31",
    "data-name": "Artboard \\u2013 31",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    transform: "translate(-10533.854 -6705.976)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 10533.85, 6705.98)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_305-2",
    "data-name": "Ellipse 305",
    className: "cls-2",
    cx: 14.421,
    cy: 14.421,
    r: 14.421,
    transform: "translate(8.08 8.16)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-3",
    d: "M7784.229,7653.693a2.555,2.555,0,0,0-2.25-2.519c-.017,0-.031,0-.035-.023h-.505c-.021.041-.063.021-.1.031a1.05,1.05,0,0,0-.743.75.992.992,0,0,1-.765.736,1.013,1.013,0,0,1-1.21-.712,1.124,1.124,0,0,0-.4-.6,1.356,1.356,0,0,0-.474-.2h-.505a.916.916,0,0,1-.273.066,2.564,2.564,0,0,0-1.989,2.489q-.007,4.129,0,8.256a1.536,1.536,0,0,0,1.182,1.5c.039.01.089,0,.117.043h1.469c.034-.044.087-.023.131-.036a1.058,1.058,0,0,0,.736-.757.985.985,0,0,1,.761-.725,1.016,1.016,0,0,1,1.211.713,1.2,1.2,0,0,0,.176.379,1.049,1.049,0,0,0,.54.383c.035.01.082,0,.105.043h1.468c.047-.045.112-.028.167-.042a1.539,1.539,0,0,0,1.18-1.486Q7784.236,7657.833,7784.229,7653.693Zm-1.025,5.06c0,.09-.018.122-.115.12-.3-.007-.594,0-.891,0a.515.515,0,1,0-.009,1.029c.3,0,.61,0,.915,0,.077,0,.1.018.1.1,0,.643,0,1.287,0,1.93a.505.505,0,0,1-.554.541c-.325-.007-.649-.021-.974-.023-.074,0-.093-.032-.113-.091a2.046,2.046,0,0,0-3.036-1.11,1.965,1.965,0,0,0-.87,1.127.121.121,0,0,1-.142.1c-.317-.006-.634,0-.952,0a.507.507,0,0,1-.546-.548c0-.639,0-1.279,0-1.918,0-.086.023-.105.106-.1q.45.008.9,0a.516.516,0,0,0,.256-.971.563.563,0,0,0-.267-.061c-.292,0-.585,0-.878,0-.106,0-.122-.031-.121-.127,0-.856,0-1.712,0-2.569,0-.808,0-1.616,0-2.424a1.533,1.533,0,0,1,1.29-1.553l.035-.007c.246-.037.256-.031.347.2a2.055,2.055,0,0,0,3.875-.078c.036-.1.076-.141.19-.134a1.531,1.531,0,0,1,1.445,1.458c.016.7.005,1.4.005,2.1C7783.2,7656.742,7783.2,7657.748,7783.2,7658.752Z",
    transform: "translate(2776.745 -928.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-3",
    d: "M7793.155,7686.89h-.493c-.18,0-.36,0-.54,0a.513.513,0,0,0-.074,1.016.406.406,0,0,0,.083.013c.352,0,.7.009,1.057,0a.512.512,0,0,0,.5-.524A.518.518,0,0,0,7793.155,7686.89Z",
    transform: "translate(2763.693 -956.791)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard31);
export default __webpack_public_path__ + "static/media/Artboard – 31.a6c826c4205b2be6c8b42936f005e143.svg";
export { ForwardRef as ReactComponent };